import { SummaryCardType } from '../types/case-tracking.enums';

export const summaryCardPeriodText = (type: SummaryCardType) => {
  switch (type) {
    case SummaryCardType.progress:
      return 'All time';
    case SummaryCardType.outstanding:
      return 'All time';
    case SummaryCardType.completed:
      return 'Last 30 days';
    default:
      return '';
  }
};
